import { MatDialog } from '@angular/material/dialog';
import { VideosDialogComponent } from '../../../auth/index/videos-dialog/videos-dialog.component';
import { BaseService } from './../../service/base.service';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { MediaMatcher } from '@angular/cdk/layout';
import { Constant } from '../../constant/constant';
import {
  StartInventoryReceivingService
} from '../../../pages/inventory-receiving/start-inventory-receiving/start-inventory-receiving.service';
import { UpdateBranchService } from '../../service/update-branch.service';
import { ReleaseNotesComponent } from '../release-notes/release-notes.component';
import { AuthService } from '../../../auth/auth.service';
import { UserProfileService } from '../../../pages/user-management/user-profile/user-profile.service';
import { environment } from '../../../../environments/environment';
import { StoreDialogComponent } from '../../../auth/index/index-footer/store-dialog/store-dialog.component';
import { GuidelineService } from '../../service/guideline.service';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef } from '@angular/core';
import { CardPermissionService } from '../../service/card-permission.service';

export interface SideMenuItem {
  nameAr: string;
  nameEn: string;
  nameFr: string;
  nameEs: string;
  id: number;
  fontIcon: string;
  active?: boolean;
  routingPath?: string;
  sortRanking?: number;
  screens?: SideMenuItem[];
}

interface CustomerTheme {
  id: number;
  statusCode: number;
  createdFromChannelId?: null | string;
  createdDate: string;
  primary: {
    background: string;
    foreground: string;
  };
  accent: {
    background: string;
    foreground: string;
  };
  text: {
    primary: string;
    secondary: string;
  };
  icon: string;
  iconPath?: string;
}

interface ThemeResponse {
  success: boolean;
  status: string;
  data: CustomerTheme;
}

interface CurrentUser {
  fullName: string;
  branchId?: number;
  userPrivilage?: {
    menu: SideMenuItem[];
  };
  branchConfig?: Branch;
}

interface Branch {
  id: number;
  customerId?: number;
  branchName?: string;
  country?: {
    id: number;
    currency: {
      code: string;
    };
  };
}

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
  providers: [Constant]
})
export class SideNavComponent implements OnChanges, OnDestroy, OnInit {
  private subscriptions = new Subscription();
  mobileQuery: MediaQueryList;
  fieldQuery: MediaQueryList;
  @Input() folded: boolean;
  sideMenu: SideMenuItem[];
  currentRoute: string;
  currentUser: CurrentUser;
  userImagePath: string;
  logoImagePath = './assets/images/newLogo.png';
  fullName: string;
  activeScreenId: number;
  branches: Branch[] = [];
  branchConfig: Branch | null = null;
  selectedItem: Branch | null = null;
  versionNumber = '1.1.2';
  isVersionChanged = false;

  constructor(
    private _router: Router,
    public _translate: TranslateService,
    private _base: BaseService,
    private _media: MediaMatcher,
    private dialog: MatDialog,
    private _service: StartInventoryReceivingService,
    private userProfileService: UserProfileService,
    public constant: Constant,
    private updateBranchService: UpdateBranchService,
    public guidelineService: GuidelineService,
    private _auth: AuthService,
    private http: HttpClient,
    private changeDetectorRef: ChangeDetectorRef,
    private cardPermissionService: CardPermissionService
  ) {
    this.subscriptions.add(
      this._base.logoUpdated.subscribe(newLogoUrl => {
        if (newLogoUrl) {
          this.logoImagePath = newLogoUrl;
          // Force change detection if needed
          this.changeDetectorRef.detectChanges();
        }
      })
    );

    // Subscribe to branch changes to refresh logo
    this.subscriptions.add(
      this.updateBranchService.subject.subscribe(() => {
        this.updateLogoImage();
      })
    );

    // Subscribe to user profile refresh to update logo and user info when user logs in
    this.subscriptions.add(
      this.userProfileService.refreshNeeded$.subscribe(() => {
        this.updateLogoImage();
        this.subscriptions.add(
          this.userProfileService.getcustomerProfile().subscribe(res => {
            console.log(res);
            this.fullName = res.user.fullName;
            this.userImagePath = environment.baseImageUrl + res.user.imagePath;
          })
        );
      })
    );

    if (sessionStorage.getItem('activeScreenId')) {
      this.activeScreenId = Number(sessionStorage.getItem('activeScreenId'));
    }
    this.mobileQuery = this._media.matchMedia('(max-width: 639px)');
    this.fieldQuery = this._media.matchMedia('(max-width: 490px)');
    _base.updateUserImage();
    this.userImagePath = this._base.userImagePath;
    this.currentUser = JSON.parse(window.localStorage.getItem('CURRENT_USER'));
    this.fullName = this.currentUser.fullName;
    // if (
    //   !this.constant.userIsCustomer() ||
    //   !this.constant.userIsEmployee()
    // ) {
    this.sideMenu = this.buildVisibleMenu(this.currentUser?.userPrivilage?.menu);
    console.log(this.currentUser)
    console.log(this.sideMenu);
    this.subscriptions.add(
      _router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          this.currentRoute = event.url;
          // Refresh logo when navigating to pages that use side-nav
          if (event.url.includes('/pages/')) {
            this.updateLogoImage();
          }
        })
    );
    this.subscriptions.add(
      this._service.getconfigBranches().subscribe(res => {
        if (res.success && res.data && res.data?.length > 0) {
          this.branches = res.data;

          // Initialize branch configuration with persistence
          this.initializeBranchConfig(res.data);
        }
      })
    );
    // }
  }
  ngOnInit() {
    this.checkVersion();
    this.updateLogoImage();
    this.logoImagePath = localStorage.getItem('LOGO_IMAGE_PATH') || './assets/images/newLogo.png';
  }

  /**
   * Hides menu entries the user cannot actually use:
   *  - screens whose card-permission state is an explicit empty allowlist
   *    (a hub the user has zero accessible cards for), and
   *  - modules left with no visible screens.
   * Screens with `cards: null` (no card-level restriction) are kept.
   */
  private buildVisibleMenu(menu?: SideMenuItem[]): SideMenuItem[] {
    if (!Array.isArray(menu)) {
      return [];
    }

    return menu
      .map((module) => {
        const screens = Array.isArray(module?.screens)
          ? module.screens.filter((screen) => this.isScreenVisible(screen))
          : [];
        return { ...module, screens };
      })
      .filter((module) => Array.isArray(module.screens) && module.screens.length > 0);
  }

  private isScreenVisible(screen?: SideMenuItem): boolean {
    if (!screen?.routingPath) {
      return true;
    }
    // Hide assigned screens that expose no usable card: an explicit empty
    // allowlist, or a card hub left without any assigned card for a role that
    // already relies on card allowlists.
    return !this.cardPermissionService.shouldHideAssignedScreen(screen.routingPath);
  }

  /**
   * Initialize branch configuration with persistence logic
   */
  private initializeBranchConfig(availableBranches: any[]) {
    const branchConfigLocal = localStorage.getItem('BRANCH_CONFIG');
    let savedBranchConfig = null;

    // Try to parse saved branch config
    if (branchConfigLocal) {
      try {
        savedBranchConfig = JSON.parse(branchConfigLocal);
      } catch (error) {
        console.warn('Error parsing BRANCH_CONFIG from localStorage:', error);
        localStorage.removeItem('BRANCH_CONFIG');
      }
    }

    if (this.constant.userIsAdmin()) {
      // For admin users
      if (savedBranchConfig && savedBranchConfig.id) {
        // Find the saved branch in available branches
        this.branchConfig = availableBranches.find(branch => branch.id === savedBranchConfig.id);
        if (this.branchConfig) {
          localStorage.setItem('BRANCH_CONFIG', JSON.stringify(this.branchConfig));
        } else {
          // Saved branch not found, fall back to default
          this.branchConfig = this.currentUser.branchConfig || availableBranches[0];
          localStorage.setItem('BRANCH_CONFIG', JSON.stringify(this.branchConfig));
        }
      } else {
        // No saved config, use default
        this.branchConfig = this.currentUser.branchConfig || availableBranches[0];
        localStorage.setItem('BRANCH_CONFIG', JSON.stringify(this.branchConfig));
      }
    } else {
      // For non-admin users
      if (this.currentUser.branchId) {
        if (savedBranchConfig && savedBranchConfig.id) {
          // Use saved branch if it exists and is valid
          this.branchConfig = availableBranches.find(branch => branch.id === savedBranchConfig.id);
          if (this.branchConfig) {
            localStorage.setItem('BRANCH_CONFIG', JSON.stringify(this.branchConfig));
          } else {
            // Saved branch not found, fall back to user's default branch
            this.branchConfig = availableBranches.find(branch => branch.id === this.currentUser.branchId);
            if (this.branchConfig) {
              localStorage.setItem('BRANCH_CONFIG', JSON.stringify(this.branchConfig));
            }
          }
        } else {
          // No saved config, use user's default branch
          this.branchConfig = availableBranches.find(branch => branch.id === this.currentUser.branchId);
          if (this.branchConfig) {
            localStorage.setItem('BRANCH_CONFIG', JSON.stringify(this.branchConfig));
          }
        }
      }
    }

    // Ensure we have a valid branch config
    if (!this.branchConfig && availableBranches.length > 0) {
      this.branchConfig = availableBranches[0];
      localStorage.setItem('BRANCH_CONFIG', JSON.stringify(this.branchConfig));
    }
  }

  // make check ont he project version to show or hide the version note
  checkVersion() {
    const storedVersion = localStorage.getItem('versionNumber');
    if (storedVersion && this.versionNumber !== storedVersion) {
      this.isVersionChanged = true;
    } else {
      this.isVersionChanged = false;
    }
    localStorage.setItem('versionNumber', this.versionNumber);
  }

  // update the logo image using customer theme API
  updateLogoImage() {
    const branchConfigJson = localStorage.getItem('BRANCH_CONFIG');
    const branchConfig = branchConfigJson ? JSON.parse(branchConfigJson) : null;
    const customerId = branchConfig ? branchConfig.customerId : null;

    console.log('SideNav: Updating logo image for customer ID:', customerId);

    if (!customerId) {
      console.log('SideNav: No customer ID found, using default logo');
      localStorage.setItem('LOGO_IMAGE_PATH', './assets/images/newLogo.png');
      localStorage.removeItem('CUSTOM_LOGO_PATH');
      this.logoImagePath = './assets/images/newLogo.png';
      return;
    }

    // Call the customer theme API
    this._auth.getUserTheme(customerId).subscribe({
      next: (response: ThemeResponse) => {
        console.log('SideNav: Customer theme API response:', response);
        if (response.success && response.data && response.data.iconPath) {
          const logoPath = environment.baseImageUrl + response.data.iconPath;
          console.log('SideNav: Setting logo path:', logoPath);
          localStorage.setItem('LOGO_IMAGE_PATH', logoPath);
          localStorage.setItem('CUSTOM_LOGO_PATH', response.data.iconPath);

          // Store theme data with logo information
          const themeData = {
            logoUrl: logoPath,
            imagePath: response.data.iconPath,
            timestamp: new Date().getTime()
          };
          localStorage.setItem('THEME_LOGO_DATA', JSON.stringify(themeData));

          // Update the logo image path
          this.logoImagePath = logoPath;
          this._base.logoUpdated.next(logoPath);
          this.changeDetectorRef.detectChanges();
        } else {
          console.log('SideNav: No icon path in response, using default logo');
          localStorage.setItem('LOGO_IMAGE_PATH', './assets/images/newLogo.png');
          localStorage.removeItem('CUSTOM_LOGO_PATH');
          this.logoImagePath = './assets/images/newLogo.png';
        }
      },
      error: (error) => {
        console.error('SideNav: Error fetching customer theme:', error);
        // If API call fails, use default logo
        localStorage.setItem('LOGO_IMAGE_PATH', './assets/images/newLogo.png');
        localStorage.removeItem('CUSTOM_LOGO_PATH');
        this.logoImagePath = './assets/images/newLogo.png';
      }
    });
  }

  // Clear logo cache and refresh logo (useful after logout/login)
  clearLogoCache() {
    console.log('SideNav: Clearing logo cache');
    localStorage.removeItem('LOGO_IMAGE_PATH');
    localStorage.removeItem('CUSTOM_LOGO_PATH');
    localStorage.removeItem('THEME_LOGO_DATA');
    this.logoImagePath = './assets/images/newLogo.png';
    this.updateLogoImage();
  }

  // remove note from side bar
  removeNote() {
    this.isVersionChanged = false;
    this.openReleaseNotesDialog()
  }
  ngOnChanges() {
    if (this.folded === true) {
      this.sideMenu.forEach((item) => {
        item.active = false;
      });
    }
  }
  toggleChildren(id: number) {
    this.sideMenu.forEach((item) => {
      if (item.id === id) {
        item.active = item.active === true ? false : true;
      } else {
        item.active = false;
      }
    });
  }

  close() {
    this._base.sideNave.next('close');
  }

  changeRoute(route, screenId: number) {
    if (this.mobileQuery.matches) {
      this._base.sideNave.next('close');
    }
    this.activeScreenId = screenId;
    sessionStorage.setItem('activeScreenId', JSON.stringify(this.activeScreenId));
    this._router.navigate([route]);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  openVideosDialog() {
    this.dialog.open(VideosDialogComponent, {
      direction: this._translate.currentLang === 'ar' ? 'rtl' : 'ltr',
      width: '500px',
      height: '300px'
    });
  }

  openReleaseNotesDialog() {
    this.dialog.open(ReleaseNotesComponent, {
      direction: this._translate.currentLang === 'ar' ? 'rtl' : 'ltr',
      width: '560px',
      maxWidth: '92vw',
      panelClass: 'release-notes-dialog-panel',
      autoFocus: false
    });
  }

  // branchChanged(branch) {

  //   localStorage.removeItem('BRANCH_CONFIG');
  //   localStorage.setItem('BRANCH_CONFIG', JSON.stringify(branch));
  //   this.updateBranchService.setBranch(branch);
  // }
  branchChanged(branch) {
    const updatedBranch = {
      ...branch,
      country: branch.country || { id: 1, currency: { code: 'USD' } }
    };

    // Update the local branch config
    this.branchConfig = updatedBranch;

    // Persist to localStorage
    localStorage.setItem('BRANCH_CONFIG', JSON.stringify(updatedBranch));

    // Update the branch service
    this.updateBranchService.setBranch(updatedBranch);

    // Refresh logo when branch changes
    this.updateLogoImage();

    console.log('Branch changed and persisted:', updatedBranch);
  }
  navTo() {
    this.sideMenu.forEach((item) => {
      item.active = false;
    });
    this.activeScreenId = -1;
    sessionStorage.setItem('activeScreenId', JSON.stringify(this.activeScreenId));
    if (this.mobileQuery.matches) {
      this._base.sideNave.next('close');
    }
    if (this.constant.userIsEmployee() || this.constant.userIsAccManager() || this.constant.userIsSupervisor()) {
      this._router.navigateByUrl('/pages/user-management/user-profile');
    }
    if (this.constant.userIsCustomer() || this.constant.userIsAdmin()) {
      this._router.navigateByUrl('/pages/shopping-customer/manage-account');
    }
  }

  openStoreDialog(store) {
    let data;
    if (store === 'appStore') {
      data = {
        'store_name': 'App Store',
        'attendance': 'https://apps.apple.com/eg/app/5dma-attendance/id6446276198',
        'provider': 'https://apps.apple.com/eg/app/مزود-خدمة-service-provider/id1601191007',
        'ecommerce': 'https://apps.apple.com/eg/app/5dma-vip-%D8%AE%D8%AF%D9%85%D8%A9-%D9%81%D9%8A-%D8%A7%D9%8A-%D8%A8%D9%8A/id1557248682'
      };
    } else if (store === 'googlePlay') {
      data = {
        'store_name': 'Google Play',
        'attendance': 'https://play.google.com/store/apps/details?id=com.DU.Khedma.attendance',
        'provider': 'https://play.google.com/store/apps/details?id=vip.khedma.khedmavip',
        'ecommerce': ''
      };
    } else if (store === 'appGallery') {
      data = {
        'store_name': 'App Gallery',
        'attendance': 'https://appgallery.huawei.com/app/C108053273',
        'provider': 'https://appgallery.huawei.com/app/C104814699',
        'ecommerce': 'https://appgallery.huawei.com/app/C104516107'
      };
    }

    this.dialog.open(StoreDialogComponent,
      {
        data: data,
      });
  }


  logout() {
    // Clear logo cache before logout
    this.clearLogoCache();
    this._auth.logout();
  }

  protected readonly MediaMatcher = MediaMatcher;
  // setItem('CURRENT_USER'
}
